import React from 'react';
import Icon from '../../../components/AppIcon';

const KPICard = ({ title, value, change, changeType, icon, trend, loading = false }) => {
  const getChangeColor = () => {
    if (changeType === 'positive') return 'text-success';
    if (changeType === 'negative') return 'text-error';
    return 'text-text-secondary';
  };

  const getChangeIcon = () => {
    if (changeType === 'positive') return 'TrendingUp';
    if (changeType === 'negative') return 'TrendingDown';
    return 'Minus';
  };

  if (loading) {
    return (
      <div className="bg-card border border-border rounded-lg p-6 shadow-elevation-1">
        <div className="animate-pulse">
          <div className="flex items-center justify-between mb-4">
            <div className="h-4 bg-muted rounded w-24"></div>
            <div className="h-8 w-8 bg-muted rounded-lg"></div>
          </div>
          <div className="h-8 bg-muted rounded w-20 mb-2"></div>
          <div className="h-4 bg-muted rounded w-16"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-card border border-border rounded-lg p-6 shadow-elevation-1 hover:shadow-elevation-2 transition-all duration-200 cursor-pointer group">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-sm font-medium text-text-secondary group-hover:text-text-primary transition-colors">
          {title}
        </h3>
        <div className="p-2 bg-primary/10 rounded-lg group-hover:bg-primary/20 transition-colors">
          <Icon name={icon} size={20} className="text-primary" />
        </div>
      </div>
      
      <div className="space-y-2">
        <p className="text-2xl font-bold text-text-primary">
          {value}
        </p>
        
        <div className="flex items-center space-x-2">
          <div className={`flex items-center space-x-1 ${getChangeColor()}`}>
            <Icon name={getChangeIcon()} size={14} />
            <span className="text-sm font-medium">{change}</span>
          </div>
          <span className="text-xs text-text-secondary">vs last period</span>
        </div>
        
        {trend && (
          <div className="mt-3 h-8 flex items-end space-x-1">
            {trend.map((point, index) => (
              <div
                key={index}
                className={`w-2 rounded-t ${
                  point > 0 ? 'bg-success/60' : 'bg-error/60'
                }`}
                style={{ height: `${Math.abs(point) * 20 + 8}px` }}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default KPICard;